import React, {
	createContext,
	Dispatch,
	ReactNode,
	SetStateAction,
	useContext,
	useState,
} from 'react';
import { CreateGroupMode } from '../Enums/CreateGroupMode.enum';
import { GroupListContent } from '../Enums/GroupListContent.enum';
import { GroupDetailListContent } from '../Enums/GroupDetailListContent.enum';

interface ContextProps {
	createGroupMode?: CreateGroupMode;
	setCreateGroupMode: Dispatch<SetStateAction<CreateGroupMode | undefined>>;
	groupListContent: GroupListContent;
	setGroupListContent: Dispatch<SetStateAction<GroupListContent>>;
	groupDetailListContent: GroupDetailListContent;
	setGroupDetailListContent: Dispatch<SetStateAction<GroupDetailListContent>>;
}

interface ProviderProps {
	children: ReactNode;
}

export const GroupsContext = createContext<ContextProps>({
	createGroupMode: undefined,
	setCreateGroupMode: () => {},
	groupListContent: GroupListContent.GROUPS,
	setGroupListContent: () => {},
	groupDetailListContent: GroupDetailListContent.MEMBERS,
	setGroupDetailListContent: () => {},
});

export const useGroupsContext = () => useContext<ContextProps>(GroupsContext);

export function GroupsContextProvider({ children }: ProviderProps) {
	const [createGroupMode, setCreateGroupMode] = useState<CreateGroupMode>();
	const [groupListContent, setGroupListContent] = useState<GroupListContent>(
		GroupListContent.GROUPS,
	);
	const [groupDetailListContent, setGroupDetailListContent] =
		useState<GroupDetailListContent>(GroupDetailListContent.MEMBERS);

	return (
		<GroupsContext.Provider
			value={{
				createGroupMode,
				setCreateGroupMode,
				groupListContent,
				setGroupListContent,
				groupDetailListContent,
				setGroupDetailListContent,
			}}>
			{children}
		</GroupsContext.Provider>
	);
}
